var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.portfolioStore.isNdf)?_c('ndf-analytics'):_c('portfolio-analytics')
}
var staticRenderFns = []

export { render, staticRenderFns }